import type { Merchant } from '~platform/entities/merchant';

import type { MultiSelectOption } from '~shared/ui/multi-select-filter';

export function getMerchantOptions(merchants: Merchant[]): MultiSelectOption[] {
  return merchants.map(({ id, name }) => ({ value: id, label: name }));
}
